import config from "../../config/index";
import requestOptions from "@/helpers/RequestOptions";
import handleResponse from "@/helpers/HandleResponses";
import handleBlobResponse from "@/helpers/HandleBlobResponses";

export const performanceService = {
  addGoal,
  getPerformanceGoal,
  getPerformanceGoals,
  getMyPerformanceGoals,
  getTeamPerformanceGoals,
  updateGoal,
  removeGoal,
  addPerformanceActivity,
  getPerformanceActivities,
  updatePerformanceActivity,
  removePerformanceActivity,
  addGoalCategory,
  getGoalCategories,
  updateGoalCategory,
  removeGoalCategory,
  addPerformanceActivityType,
  getPerformanceActivityTypes,
  updatePerformanceActivityType,
  removePerformanceActivityType,
  addPerformanceActivitySource,
  getPerformanceActivitySources,
  updatePerformanceActivitySource,
  removePerformanceActivitySource,
  addPerformanceActivityStatus,
  updatePerformanceActivityStatus,
  getPerformanceActivityStatuses,
  updatePerformanceActivityStatus,
  removePerformanceActivityStatus,
  addJournalComment,
  updateJournalComment,
  removeJournalComment,
  addJournalAttachment,
  removeJournalAttachment,
  addGoalAttachment,
  removeGoalAttachment,
  addJournal,
  getJournal,
  getJournals,
  getJournalsByWorker,
  updateJournal,
  removeJournal,
  addKPIRating,
  getKPIRatingsByGoal,
  updateKPIRatings,
  addKPI,
  getKPIs,
  updateKPIs,
  removeKPI,
  addMeasurement,
  getMeasurements,
  updateMeasurement,
  removeMeasurement,
  addGoalMeasurement,
  updateGoalMeasurement,
  removeGoalMeasurement,
  addGoalActivity,
  editGoalActivity,
  removeGoalActivity,
  addFieldSet,
  getFieldSets,
  getMeasureableFieldSets,
  getThirdRaterGoals,
  getEmployeePerformanceGoals,
  updateFieldSet,
  removeFieldSet,
  addActivitySet,
  updateActivitySet,
  removeActivitySet,
  addReview,
  updateReview,
  updateReviewByManager,
  getReviewsByCompany,
  exportReviewsByPeriod,
  getReviewsByPeriod,
  getReviewByEmployee,
  getReviewsByManager,
  getReviewsByMgt,
  getActiveReviewPeriodByEmployee,
  getReview,
  getQuestionSettings,
  addQuestionSettings,
  updateQuestionSettings,
  deleteQuestionSettings,
  getReviewPeriods,
  addReviewPeriod,
  updateReviewPeriod,
  removeReviewPeriod,
  getReviewsByOther,
  updateReviewByHr,
  importKPI
};

function addGoal(
  description,
  startDate,
  endDate,
  categoryId,
  employeeId,
  completion,
  title
) {
  var req = {
    description,
    startDate,
    endDate,
    categoryId,
    employeeId,
    completion,
    title
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/AddGoal`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getPerformanceGoal(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetPerformanceGoal/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getPerformanceGoals(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetPerformanceGoals/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getMyPerformanceGoals() {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetMyPerformanceGoals`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getThirdRaterGoals(employeeId) {
  return fetch(
    `${config.apiurl}/Summary/GetThirdRaterGoals/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getReviewsByOther(employeeId) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetEmployeeReviewsByOther/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getReviewsByManager(employeeId) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetEmployeeReviewsByManager/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getReviewsByMgt(positionId) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetEmployeeReviewsByMgt/${positionId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getReviewsByCompany(companyId) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetEmployeeReviewsByCompany/${companyId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getReviewsByPeriod(Id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetMiniEmployeeReviewsByPeriod/${Id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function exportReviewsByPeriod(Id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/ExportEmployeeReviewsByPeriod/${Id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getActiveReviewPeriodByEmployee(employeeId) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetActiveReviewPeriod/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getReviewByEmployee(employeeId) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetEmployeeReviewByEmployee/${employeeId}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getReview(Id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetEmployeeReviewDetail/${Id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getEmployeePerformanceGoals(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetEmployeePerformanceGoals/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getTeamPerformanceGoals(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetTeamPerformanceGoals`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updateGoal(
  id,
  description,
  startDate,
  endDtate,
  categoryId,
  employeeId,
  completion,
  title,
  thirdrater,
  status
) {
  // thirdrater.goalId = id;
  var req = {
    id,
    description,
    startDate,
    endDtate,
    categoryId,
    employeeId,
    completion,
    title,
    goalThirdRater: thirdrater,
    status
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateGoal/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeGoal(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveGoal/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addPerformanceActivity(
  status,
  typeId,
  sourceId,
  statusId,
  employeeId,
  activityDate
) {
  var req = {
    status,
    typeId,
    sourceId,
    statusId,
    employeeId,
    activityDate
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/AddPerfomanceActivity`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getPerformanceActivities(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetPerfomanceActivities/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updatePerformanceActivity(
  id,
  status,
  typeId,
  sourceId,
  statusId,
  employeeId,
  activityDate
) {
  var req = {
    id,
    status,
    typeId,
    sourceId,
    statusId,
    employeeId,
    activityDate
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdatePerformanceActivity/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removePerformanceActivity(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemovePerformanceActivity/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addGoalCategory(companyId, status, name) {
  var req = {
    companyId,
    status,
    name
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/AddGoalCategory`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getGoalCategories(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetGoalCategories/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updateGoalCategory(id, companyId, status, name) {
  var req = {
    id,
    companyId,
    status,
    name
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateGoalCategory/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeGoalCategory(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveGoalCategory/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addPerformanceActivityType(companyId, status, name) {
  var req = {
    companyId,
    status,
    name
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/AddPerformanceActivityType`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addReview(req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/AddEmployeeReview`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getPerformanceActivityTypes(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetPerformanceActivityTypes/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updatePerformanceActivityType(id, companyId, status, name) {
  var req = {
    id,
    companyId,
    status,
    name
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdatePerformanceActivityType/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateReview(id, req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateEmployeeReview/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateReviewByHr(id, req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateEmployeeReviewByHr/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateReviewByManager(id, req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateEmployeeReviewByManager/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removePerformanceActivityType(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemovePersonalExcellenceSettings/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addPerformanceActivitySource(companyId, status, name) {
  var req = {
    companyId,
    status,
    name
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/AddPerformanceActivitySource`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getPerformanceActivitySources(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetPerformanceActivitySources/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updatePerformanceActivitySource(id, companyId, status, name) {
  var req = {
    id,
    companyId,
    status,
    name
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdatePerformanceActivitySource/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removePerformanceActivitySource(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemovePerformanceActivitySource/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addPerformanceActivityStatus(companyId, status, name) {
  var req = {
    companyId,
    status,
    name
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/AddPerformanceActivityStatus`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getPerformanceActivityStatuses(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetPerformanceActivityStatuses/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updatePerformanceActivityStatus(id, companyId, status, name) {
  var req = {
    id,
    companyId,
    status,
    name
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdatePerformanceActivityStatus/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removePerformanceActivityStatus(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemovePerformanceActivityStatus/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addFieldSet(companyId, name, type, measureable) {
  var req = {
    companyId,
    type,
    name,
    measureable
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/AddFieldSet`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getFieldSets(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetFieldSets/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getMeasureableFieldSets(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetMeasureableFieldSets/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updateFieldSet(req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateFieldSet/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeFieldSet(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveFieldSet/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getQuestionSettings(id) {
  return fetch(
    `${config.apiurl}/performancereview/getquestionsettings/${id}`,
    requestOptions.get(id)
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function addQuestionSettings(companyId, topic) {
  var req = {
    companyId,
    topic
  };
  return fetch(
    `${config.apiurl}/performancereview/addquestionsetting/`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateQuestionSettings(req) {
  return fetch(
    `${config.apiurl}/performancereview/updatequestionsetting/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function deleteQuestionSettings(id) {
  return fetch(
    `${config.apiurl}/performancereview/removequestionsetting/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addActivitySet(req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/AddActivitySet`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateActivitySet(req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateActivitySet/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeActivitySet(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveActivitySet/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addJournalComment(status, journalId, comment, submittedBy) {
  var req = {
    status,
    journalId,
    comment,
    submittedBy
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/AddJournalComment`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateJournalComment(id, status, journalId, comment, submittedBy) {
  var req = {
    id,
    status,
    journalId,
    comment,
    submittedBy
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateJournalComment/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeJournalComment(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveJournalComment/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addJournalAttachment(status, journalId, title, cv, companyId) {
  let formData = new FormData();
  formData.append("Title", title);
  formData.append("Status", status);
  formData.append("JournalId", journalId);
  formData.append("Uploadfile", cv);
  return fetch(
    `${config.apiurl}/PerformanceReview/AddJournalAttachment/${companyId}`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeJournalAttachment(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveJournalAttachment/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}


function addGoalAttachment(status, journalId, title, cv, companyId) {
  let formData = new FormData();
  formData.append("Title", title);
  formData.append("Status", status);
  formData.append("GoalId", journalId);
  formData.append("Uploadfile", cv);
  return fetch(
    `${config.apiurl}/PerformanceReview/AddGoalAttachment/${companyId}`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeGoalAttachment(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveGoalAttachment/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addJournal(
  status,
  employeeId,
  title,
  description,
  journalDate,
  source,
  startDate,
  dateCompleted,
  share,
  submittedBy
) {
  var req = {
    status,
    employeeId,
    title,
    description,
    journalDate,
    source,
    startDate,
    dateCompleted,
    share,
    submittedBy
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/AddJournal`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getJournals(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetJournals/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getJournal(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetJournal/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function getJournalsByWorker(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetJournalsByWorker/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updateJournal(
  id,
  status,
  employeeId,
  title,
  description,
  journalDate,
  source,
  startDate,
  dateCompleted,
  share,
  submittedBy
) {
  var req = {
    id,
    status,
    employeeId,
    title,
    description,
    journalDate,
    source,
    startDate,
    dateCompleted,
    share,
    submittedBy
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateJournal/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeJournal(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveJournal/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addKPIRating(status, goalMeasurementId, rate, submittedBy) {
  var req = {
    status,
    goalMeasurementId,
    rate,
    submittedBy
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/addKPIRating`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getKPIRatingsByGoal(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/getKPIRatingsByGoal/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updateKPIRatings(req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateKPIRatings`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function importKPI(file) {
  let formData = new FormData();
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/PerformanceReview/importDesignationKPI`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addKPI(
  companyUnitId,
  title,
  description,
  desinationId,
  weight,
  // measureableFieldset,
  // expFieldSetValue,
  // method,
  type
) {
  var req = {
    companyUnitId,
    status: 0,
    title,
    description,
    desinationId,
    weight,
    // measureableFieldset,
    // expFieldSetValue,
    // method,
    type: parseInt(type),
  };
  console.log(`req`, req)
  //console.log(`year`, req.year)
  return fetch(
    `${config.apiurl}/PerformanceReview/AddDesignationKPI`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getKPIs(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetDesignationKPIs/${id}`,
    // `${config.apiurl}/PerformanceReview/GetKPIs/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updateKPIs(req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateDesignationKPI`,
    // `${config.apiurl}/PerformanceReview/UpdateKPI/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeKPI(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveDesignationKPI/${id}`,
    // `${config.apiurl}/PerformanceReview/RemoveKPI/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getReviewPeriods(id) {
  return fetch(
    `${config.apiurl}/performanceReview/GetReviewPeriods/${id}`,
    // `${config.apiurl}/PerformanceReview/GetKPIs/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function addReviewPeriod(
  req
) {
  console.log(`req`, req)
  //console.log(`year`, req.year)
  return fetch(
    `${config.apiurl}/performanceReview/AddReviewPeriod`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateReviewPeriod(req) {
  return fetch(
    `${config.apiurl}/performanceReview/UpdateReviewPeriod`,
    // `${config.apiurl}/PerformanceReview/UpdateKPI/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeReviewPeriod(id) {
  return fetch(
    `${config.apiurl}/performanceReview/RemoveReviewPeriod/${id}`,
    // `${config.apiurl}/PerformanceReview/RemoveKPI/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addMeasurement(status, kpiId, target) {
  var req = {
    status,
    kpiId,
    target
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/AddMeasurement`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getMeasurements(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/GetMeasurements/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}

function updateMeasurement(id, status, kpiId, target) {
  var req = {
    id,
    status,
    kpiId,
    target
  };
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateMeasurement/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeMeasurement(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveMeasurement/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addGoalMeasurement(req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/AddGoalMeasurement`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function updateGoalMeasurement(req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateGoalMeasurement/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function removeGoalMeasurement(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveGoalMeasurement/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addGoalActivity(req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/AddGoalActivity`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function editGoalActivity(req) {
  return fetch(
    `${config.apiurl}/PerformanceReview/UpdateGoalActivity/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeGoalActivity(id) {
  return fetch(
    `${config.apiurl}/PerformanceReview/RemoveGoalActivity/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}



// WEBPACK FOOTER //
// ./src/services/performanceService.js